export var DataClassification;
(function (DataClassification) {
    // tslint:disable:no-bitwise
    DataClassification[DataClassification["EssentialServiceMetadata"] = 1] = "EssentialServiceMetadata";
    DataClassification[DataClassification["AccountData"] = 2] = "AccountData";
    DataClassification[DataClassification["SystemMetadata"] = 4] = "SystemMetadata";
    DataClassification[DataClassification["OrganizationIdentifiableInformation"] = 8] = "OrganizationIdentifiableInformation";
    DataClassification[DataClassification["EndUserIdentifiableInformation"] = 16] = "EndUserIdentifiableInformation";
    DataClassification[DataClassification["CustomerContent"] = 32] = "CustomerContent";
    DataClassification[DataClassification["AccessControl"] = 64] = "AccessControl";
})(DataClassification || (DataClassification = {}));
//# sourceMappingURL=DataClassification.js.map